import { ButtonProps } from '@mui/material/Button'

import Button from '../ui/Button'
import SubmitButtonFromState from './SubmitButtonFromState'

type ComponentProps = ButtonProps & {
  control?: any
}

function FormButton(props: ComponentProps): JSX.Element {
  const { control, ...buttonProps } = props

  return (
    <SubmitButtonFromState
      control={control}
      render={({ isSubmitting, isDirty }) => (
        <Button disabled={isSubmitting || !isDirty} isLoading={isSubmitting} {...buttonProps} />
      )}
    />
  )
}

export default FormButton
